// // App.jsx
// import { useState, useRef, useEffect } from 'react';

// import { Toaster } from 'react-hot-toast';
// import { TypeAnimation } from 'react-type-animation';
// import { Navbar } from './layout/NavBar';
// import { HeroSection } from './components/HeroSection';
// import Projects from './components/Projects';
// import { About } from './components/About';
// import { Skills } from './components/Skills';
// import Portfolio from './pages/Portfolio';
// import HomeWaterFiltration from './pages/Home';

// const App = () => {
//   const [activeSection, setActiveSection] = useState('home');
//   const sectionsRef = useRef({});

//   const registerSectionRef = (sectionName, node) => {
//     if (node) {
//       sectionsRef.current[sectionName] = node;
//     }
//   };

//   const scrollToSection = (section) => {
//     const element = sectionsRef.current[section];
//     if (element) {
//       element.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start',
//       });
//     }
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollPosition = window.scrollY + window.innerHeight / 2;
//       const sections = Object.entries(sectionsRef.current);

//       for (const [sectionName, sectionElement] of sections) {
//         const { top, bottom } = sectionElement.getBoundingClientRect();
//         const offsetTop = top + window.scrollY;
//         const offsetBottom = bottom + window.scrollY;

//         if (scrollPosition >= offsetTop && scrollPosition <= offsetBottom) {
//           setActiveSection(sectionName);
//           break;
//         }
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <div className="bg-primary min-h-screen font-poppins">
//       <HomeWaterFiltration />
//     </div>
//   );
// };

// export default App;

// App.jsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import HomeWaterFiltration from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactPage';
import WholeHomeWaterFiltration from './pages/ProductPage';


const App = () => {
  const [activeSection, setActiveSection] = useState('home');
  const sectionsRef = useRef({});

  // const registerSectionRef = (sectionName, node) => {
  //   if (node) {
  //     sectionsRef.current[sectionName] = node;
  //   }
  // };

  // const scrollToSection = (section) => {
  //   const element = sectionsRef.current[section];
  //   if (element) {
  //     element.scrollIntoView({
  //       behavior: 'smooth',
  //       block: 'start',
  //     });
  //   }
  // };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      const sections = Object.entries(sectionsRef.current);

      for (const [sectionName, sectionElement] of sections) {
        const { top, bottom } = sectionElement.getBoundingClientRect();
        const offsetTop = top + window.scrollY;
        const offsetBottom = bottom + window.scrollY;

        if (scrollPosition >= offsetTop && scrollPosition <= offsetBottom) {
          setActiveSection(sectionName);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    // <Router>
    //   <div className="bg-primary min-h-screen font-poppins">
    //     <Toaster />
    //     <Navbar scrollToSection={scrollToSection} activeSection={activeSection} />
    //     <Routes>
    //       <Route path="/home" element={<HomeWaterFiltration />} />
    //       <Route path="/about-us" element={<AboutUs />} />
    //     </Routes>
    //   </div>
    // </Router>
<Router>
     <Routes>
          <Route path="/" element={<HomeWaterFiltration />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={ <ContactUs />} />
                    <Route path="/water-filtaration" element={ <WholeHomeWaterFiltration />} />

        </Routes>
</Router>

  );
};

export default App;
